import { CUSTOM_DOMAIN_CACHE_KEY, CustomDomainOrg, getCachedCustomDomainOrg, isCustomDomain } from './domain';

/**
 * On a custom domain, make sure the hostname→org mapping is cached before the
 * Router renders (Router picks its whole tree off getOrgSlugFromHostname()).
 * Returns true when the app can proceed as an org domain.
 */
export const resolveCustomDomain = async (): Promise<boolean> => {
  if (!isCustomDomain()) return true;
  if (getCachedCustomDomainOrg()) {
    void refresh(); // refresh cache in the background, don't block boot
    return true;
  }
  return refresh();
};

const refresh = async (): Promise<boolean> => {
  try {
    const url = new URL(import.meta.env.VITE_ENDPOINT);
    url.pathname = '/custom-domain/resolve';
    url.searchParams.set('host', window.location.hostname);
    const res = await fetch(url.toString());
    if (!res.ok) return false;
    const data = await res.json();
    const entry: CustomDomainOrg = {
      hostname: window.location.hostname,
      organizationId: data.organizationId,
      slug: data.slug,
      logoUrl: data.logoUrl ?? null,
    };
    localStorage.setItem(CUSTOM_DOMAIN_CACHE_KEY, JSON.stringify(entry));
    return true;
  } catch {
    return false;
  }
};
